import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector} from 'react-redux'
import PropTypes from 'prop-types';
import { lighten, makeStyles } from '@material-ui/core/styles';
import { Checkbox } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },   
  heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },    
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
}));

export default function EnhancedTableHead(props) {
    //const { headCells, classes, order, orderBy, onRequestSort } = props;
    const { headCellState, order, orderBy, onRequestSort } = props;

    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    const classes = useStyles();
    const {t} = useTranslation('batchManagement');
    const dispatch = useDispatch();
  
    return (
      <TableHead >
        <TableRow>
          {headCellState.map((headCell) => (
              (headCell.id === "dispatch_no") || (headCell.id === "eta")
              ?
                <TableCell
                  key={headCell.id}
                  style={{ minWidth: headCell.width }}
                  sortDirection={orderBy === headCell.id ? order : false}
                >
                <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={createSortHandler(headCell.id)}
                >
                    {t(headCell.label)}
                    {orderBy === headCell.id ? (
                    <span className={classes.visuallyHidden}>
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                    ) : null}
                </TableSortLabel>
                </TableCell>
              :
                <TableCell
                  key={headCell.id}    
                  style={{ minWidth: headCell.width }}
                >
                  {t(headCell.label)}
                </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );

  }    


  EnhancedTableHead.propTypes = {
    //classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
  };